// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesItem-containerWith-G0yaQ {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.MessagesItem-container-Rqjuk {
    max-width: 100%;
}

/* Text - Start */

.MessagesItem-subText-TNjiC {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.MessagesItem-navigationLink-sIH5y a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.MessagesItem-navigationLink-sIH5y a:hover,
.MessagesItem-navigationLink-sIH5y a:focus,
.MessagesItem-navigationLink-sIH5y a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.MessagesItem-noPadding-XlSNE {
    padding: 0;
}

.MessagesItem-heading-hlS1w {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.MessagesItem-widthInner-h0h70 {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.MessagesItem-noMargin-c7ASw {
    margin: 0;
}

.MessagesItem-formControlInputTable-V1Owr {
    border: none;
    width: 100px;
    height: auto;
}

.MessagesItem-backBtn-_u8y_ {
    margin-left: 15px;
    display: inline-block;
}

.MessagesItem-backBtn-_u8y_:active,
.MessagesItem-backBtn-_u8y_:hover,
.MessagesItem-backBtn-_u8y_:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.MessagesItem-textAlignRight-jXS4U {
    text-align: right;
}

.MessagesItem-displayInlineBlock-gzqa5 {
    display: inline-block;
}

.MessagesItem-displayBlock-AoyrU {
    display: block;
}

.MessagesItem-countryCode-dCLJI {
    width: 15%;
    vertical-align: top;
}

.MessagesItem-vtrMiddle-S26Rn {
    vertical-align: middle;
}

/* commonCss */

.MessagesItem-editIcon-GZyZk {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.MessagesItem-iconBtn-w_2Ux,
.MessagesItem-iconBtn-w_2Ux:hover,
.MessagesItem-iconBtn-w_2Ux:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.MessagesItem-profileImg-Gjb_h {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.MessagesItem-profileImgSection-gJWil {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.MessagesItem-profileImgWidth-mJIOI {
    margin: 0;
    max-width: 100% !important;
}

.MessagesItem-searchInput-EmJdb {
    width: 100%;
    max-width: 320px;
}

.MessagesItem-backgroundImg-pG2wA {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.MessagesItem-exportDisplay-WBn4R {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.MessagesItem-exportTextSection-x4RtQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.MessagesItem-exportText-_QFw7 {
    display: inline-block;
    padding-right: 5px;
}

.MessagesItem-exportTextContainer-ETnMj {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.MessagesItem-vtrTextBottom-eYsFF {
    vertical-align: text-bottom;
}

.MessagesItem-exportImg-XnlHg {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.MessagesItem-noLink-lIClA,
.MessagesItem-noLink-lIClA:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.MessagesItem-singleCard-M47C5 {
    width: 500px;
    margin: 0 auto;
}

.MessagesItem-defaultIcon-sdLlJ {
    background-size: 50px;
}

.MessagesItem-assignProviderSearchInput-XCw2w {
    width: 100%;
    max-width: 324px;
}

.MessagesItem-searchGroupContainer-Z7GIJ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .MessagesItem-searchGroupContainer-Z7GIJ {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .MessagesItem-widthInner-h0h70 {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .MessagesItem-aboutGrid-byr4A img {
    position: relative;
    top: -25px !important;
  }

  .MessagesItem-responsiveView-oSS54 {
    width: 100% !important;
    max-width: 175px !important;
  }

  .MessagesItem-positionFive-blsne {
    top: 28% !important;
  }

  .MessagesItem-positionTwo-IFIJW {
    top: 28% !important;
  }

  .MessagesItem-responsiveContentOne-U2uo6 {
    top: -50px !important;
  }

  .MessagesItem-positionFour-rTZup {
    top: -50px !important;
  }

  .MessagesItem-totalCss-jzyQa {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .MessagesItem-navbar-expand-lg-ud5Hu .MessagesItem-navbar-toggler-VpPXm {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .MessagesItem-profileImgSection-gJWil {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .MessagesItem-navigationLink-sIH5y a {
    color: var(--primary-foreground) !important;
  }

  .MessagesItem-widthInner-h0h70 {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .MessagesItem-responsiveContentOne-U2uo6 {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .MessagesItem-positionTwo-IFIJW {
    top: 24% !important;
    left: -5% !important;
  }

  .MessagesItem-positionThree-o0eP0 {
    top: 70% !important;
    left: -5% !important;
  }

  .MessagesItem-positionFour-rTZup {
    top: -42px !important;
    right: -5% !important;
  }

  .MessagesItem-positionFive-blsne {
    top: 20% !important;
    right: -5% !important;
  }

  .MessagesItem-positionSix-jtkxQ {
    top: 70% !important;
    right: -5% !important;
  }

  .MessagesItem-responsiveView-oSS54 {
    width: 100% !important;
    max-width: 115px !important;
  }

  .MessagesItem-aboutGrid-byr4A img {
    top: -1px !important;
  }

  .MessagesItem-contentOne-DvBsz h1 {
    font-size: 16px !important;
  }

  .MessagesItem-contentOne-DvBsz p {
    font-size: 12px !important;
  }


  .MessagesItem-totalCss-jzyQa {
    width: 100% !important;
  }

  .MessagesItem-padding-NUlfH {
    padding: 0px 0 0 60px !important;
  }

  .MessagesItem-singleCard-M47C5 {
    width: 100% !important;
  }

  .MessagesItem-navigationLink-sIH5y a:hover,
  .MessagesItem-navigationLink-sIH5y a:focus,
  .MessagesItem-navigationLink-sIH5y a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .MessagesItem-navbar-collapse-tM7Ym.MessagesItem-show-B3RJT {
    right: 0% !important;
    top: 0 !important;
  }

  .MessagesItem-navbar-collapse-tM7Ym {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .MessagesItem-content-JUmoC {
    float: none;
  }

  .MessagesItem-mr-auto-W5Fi5.MessagesItem-navbar-nav-aqLHb {
    padding-bottom: 80px !important;
  }

  .MessagesItem-navigationLink-sIH5y a {
    color: var(--primary-foreground) !important;
  }

  .MessagesItem-footer-TE_l3 {
    padding: 35px 0 0 15px;
  }

  .MessagesItem-widthInner-h0h70 {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .MessagesItem-responsiveNoPadding-RXIVi {
    padding: 0px !important;
  }

  .MessagesItem-contentOne-DvBsz {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .MessagesItem-aboutContainer-YDS9v {
    padding: 30px 0 30px !important;
  }

  .MessagesItem-noPosition-h2e6j {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .MessagesItem-mobimleImg-vT_cu {
    display: none !important;
  }

  .MessagesItem-totalCss-jzyQa {
    width: 100% !important;
  }

  .MessagesItem-imgWidth-qBByd {
    padding: 18px !important;
  }

  .MessagesItem-searchInput-EmJdb,
  .MessagesItem-assignProviderSearchInput-XCw2w {
    max-width: 100% !important;
  }

  .MessagesItem-exportText-_QFw7 {
    display: inline-block;
  }

  .MessagesItem-gridSystem-O1C9Z {
    grid-template-columns: auto !important;
  }

  .MessagesItem-padding-NUlfH {
    padding: 52px 0 0 0 !important;
  }

  .MessagesItem-heading-hlS1w {
    padding: 30px 0 24px !important;
  }

  .MessagesItem-singleCard-M47C5 {
    width: 100% !important;
  }

  .MessagesItem-displayGrid-surVn {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .MessagesItem-boxInner-ts0ye {
    padding: 35px 0 !important;
  }

  .MessagesItem-navigationLink-sIH5y a:hover,
  .MessagesItem-navigationLink-sIH5y a:focus,
  .MessagesItem-navigationLink-sIH5y a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .MessagesItem-whiteDropdown-nqpY7 select {
    width: 120px !important;
  }
}

.MessagesItem-displayFlexSender-ND9T0 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
}

.MessagesItem-displayFlexReverse-lQaA0 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
        -ms-flex-direction: row-reverse;
            flex-direction: row-reverse;
}

.MessagesItem-avatarImage-fXlEy {
    border-radius: 50%;
    width: 100%;
    max-width: 48px;
    height: 48px;
}

.MessagesItem-linkText-dbs2t {
    display: inline-block;
    margin-bottom: 12px;
}

.MessagesItem-noPadding-XlSNE {
    padding: 0px;
}

.MessagesItem-avartarSectionWidth-T5PEh {
    width: 50px;
    margin-right: 6px;
}

.MessagesItem-senderPadding-NuLWx {
    width: 95%;
    border: 1px solid var(--primary-border);
    height: auto;
    min-height: 60px;
    padding: 20px;
    border-radius: 0px 30px 30px 30px;
    text-align: left;
    word-break: break-word;
}

.MessagesItem-receiverPadding-QjZSa {
    width: 95%;
    border: 1px solid var(--primary-border);
    height: auto;
    min-height: 60px;
    padding: 20px;
    border-radius: 30px 0px 30px 30px;
    word-break: break-word;
}

.MessagesItem-imageRight-Ot4cw {
    text-align: right;
    margin-right: 0px;
    margin-left: 6px;
}

.MessagesItem-bgImage-lFn5a {
    width: 100%;
    height: auto;
    border-radius: 50px;
    padding-top: 100%;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
}

.MessagesItem-senderBgScetion-XkuQn {
    width: 65px;
    margin-right: 6px;
}

.MessagesItem-recsiverBgScetion-eum0R {
    width: 65px;
    margin-left: 6px;
}

.MessagesItem-textCenter-jzUjS {
    text-align: center;
}

.MessagesItem-batchIcon-zB2Rc {
    position: absolute;
    bottom: -15px;
    right: -1px;
    width: 20px;
}

.MessagesItem-positionRelative-eTR2Q {
    position: relative;
}

.MessagesItem-batchIconDriver-bCuzg {
    position: absolute;
    bottom: 0;
    right: -1px;
    width: 20px;
}

@media (max-width: 1199px) and (min-width: 768px) {
    .MessagesItem-avartarSectionWidth-T5PEh {
        width: 50px;
        margin-right: 6px;
    }

    .MessagesItem-senderPadding-NuLWx {
        width: 95%;
    }

    .MessagesItem-receiverPadding-QjZSa {
        width: 95%;
    }
}

@media screen and (max-width: 767px) {
    .MessagesItem-avartarSectionWidth-T5PEh {
        width: 50px;
    }

    .MessagesItem-senderPadding-NuLWx {
        width: 95%;
    }

    .MessagesItem-receiverPadding-QjZSa {
        width: 95%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/SiteAdmin/ChatMessages/MessagesItem.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,8BAAmB;IAAnB,6BAAmB;QAAnB,uBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,8BAA2B;IAA3B,8BAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n.displayFlexSender {\n    display: flex;\n    flex-direction: row;\n}\n\n.displayFlexReverse {\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n.avatarImage {\n    border-radius: 50%;\n    width: 100%;\n    max-width: 48px;\n    height: 48px;\n}\n\n.linkText {\n    display: inline-block;\n    margin-bottom: 12px;\n}\n\n.noPadding {\n    padding: 0px;\n}\n\n.avartarSectionWidth {\n    width: 50px;\n    margin-right: 6px;\n}\n\n.senderPadding {\n    width: 95%;\n    border: 1px solid var(--primary-border);\n    height: auto;\n    min-height: 60px;\n    padding: 20px;\n    border-radius: 0px 30px 30px 30px;\n    text-align: left;\n    word-break: break-word;\n}\n\n.receiverPadding {\n    width: 95%;\n    border: 1px solid var(--primary-border);\n    height: auto;\n    min-height: 60px;\n    padding: 20px;\n    border-radius: 30px 0px 30px 30px;\n    word-break: break-word;\n}\n\n.imageRight {\n    text-align: right;\n    margin-right: 0px;\n    margin-left: 6px;\n}\n\n.bgImage {\n    width: 100%;\n    height: auto;\n    border-radius: 50px;\n    padding-top: 100%;\n    background-position: 50% 50%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    position: relative;\n}\n\n.senderBgScetion {\n    width: 65px;\n    margin-right: 6px;\n}\n\n.recsiverBgScetion {\n    width: 65px;\n    margin-left: 6px;\n}\n\n.textCenter {\n    text-align: center;\n}\n\n.batchIcon {\n    position: absolute;\n    bottom: -15px;\n    right: -1px;\n    width: 20px;\n}\n\n.positionRelative {\n    position: relative;\n}\n\n.batchIconDriver {\n    position: absolute;\n    bottom: 0;\n    right: -1px;\n    width: 20px;\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n    .avartarSectionWidth {\n        width: 50px;\n        margin-right: 6px;\n    }\n\n    .senderPadding {\n        width: 95%;\n    }\n\n    .receiverPadding {\n        width: 95%;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .avartarSectionWidth {\n        width: 50px;\n    }\n\n    .senderPadding {\n        width: 95%;\n    }\n\n    .receiverPadding {\n        width: 95%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `MessagesItem-containerWith-G0yaQ`,
	"container": `MessagesItem-container-Rqjuk`,
	"subText": `MessagesItem-subText-TNjiC`,
	"navigationLink": `MessagesItem-navigationLink-sIH5y`,
	"noPadding": `MessagesItem-noPadding-XlSNE`,
	"heading": `MessagesItem-heading-hlS1w`,
	"widthInner": `MessagesItem-widthInner-h0h70`,
	"noMargin": `MessagesItem-noMargin-c7ASw`,
	"formControlInputTable": `MessagesItem-formControlInputTable-V1Owr`,
	"backBtn": `MessagesItem-backBtn-_u8y_`,
	"textAlignRight": `MessagesItem-textAlignRight-jXS4U`,
	"displayInlineBlock": `MessagesItem-displayInlineBlock-gzqa5`,
	"displayBlock": `MessagesItem-displayBlock-AoyrU`,
	"countryCode": `MessagesItem-countryCode-dCLJI`,
	"vtrMiddle": `MessagesItem-vtrMiddle-S26Rn`,
	"editIcon": `MessagesItem-editIcon-GZyZk`,
	"iconBtn": `MessagesItem-iconBtn-w_2Ux`,
	"profileImg": `MessagesItem-profileImg-Gjb_h`,
	"profileImgSection": `MessagesItem-profileImgSection-gJWil`,
	"profileImgWidth": `MessagesItem-profileImgWidth-mJIOI`,
	"searchInput": `MessagesItem-searchInput-EmJdb`,
	"backgroundImg": `MessagesItem-backgroundImg-pG2wA`,
	"exportDisplay": `MessagesItem-exportDisplay-WBn4R`,
	"exportTextSection": `MessagesItem-exportTextSection-x4RtQ`,
	"exportText": `MessagesItem-exportText-_QFw7`,
	"exportTextContainer": `MessagesItem-exportTextContainer-ETnMj`,
	"vtrTextBottom": `MessagesItem-vtrTextBottom-eYsFF`,
	"exportImg": `MessagesItem-exportImg-XnlHg`,
	"noLink": `MessagesItem-noLink-lIClA`,
	"singleCard": `MessagesItem-singleCard-M47C5`,
	"defaultIcon": `MessagesItem-defaultIcon-sdLlJ`,
	"assignProviderSearchInput": `MessagesItem-assignProviderSearchInput-XCw2w`,
	"searchGroupContainer": `MessagesItem-searchGroupContainer-Z7GIJ`,
	"aboutGrid": `MessagesItem-aboutGrid-byr4A`,
	"responsiveView": `MessagesItem-responsiveView-oSS54`,
	"positionFive": `MessagesItem-positionFive-blsne`,
	"positionTwo": `MessagesItem-positionTwo-IFIJW`,
	"responsiveContentOne": `MessagesItem-responsiveContentOne-U2uo6`,
	"positionFour": `MessagesItem-positionFour-rTZup`,
	"totalCss": `MessagesItem-totalCss-jzyQa`,
	"navbar-expand-lg": `MessagesItem-navbar-expand-lg-ud5Hu`,
	"navbar-toggler": `MessagesItem-navbar-toggler-VpPXm`,
	"positionThree": `MessagesItem-positionThree-o0eP0`,
	"positionSix": `MessagesItem-positionSix-jtkxQ`,
	"contentOne": `MessagesItem-contentOne-DvBsz`,
	"padding": `MessagesItem-padding-NUlfH`,
	"navbar-collapse": `MessagesItem-navbar-collapse-tM7Ym`,
	"show": `MessagesItem-show-B3RJT`,
	"content": `MessagesItem-content-JUmoC`,
	"mr-auto": `MessagesItem-mr-auto-W5Fi5`,
	"navbar-nav": `MessagesItem-navbar-nav-aqLHb`,
	"footer": `MessagesItem-footer-TE_l3`,
	"responsiveNoPadding": `MessagesItem-responsiveNoPadding-RXIVi`,
	"aboutContainer": `MessagesItem-aboutContainer-YDS9v`,
	"noPosition": `MessagesItem-noPosition-h2e6j`,
	"mobimleImg": `MessagesItem-mobimleImg-vT_cu`,
	"imgWidth": `MessagesItem-imgWidth-qBByd`,
	"gridSystem": `MessagesItem-gridSystem-O1C9Z`,
	"displayGrid": `MessagesItem-displayGrid-surVn`,
	"boxInner": `MessagesItem-boxInner-ts0ye`,
	"whiteDropdown": `MessagesItem-whiteDropdown-nqpY7`,
	"displayFlexSender": `MessagesItem-displayFlexSender-ND9T0`,
	"displayFlexReverse": `MessagesItem-displayFlexReverse-lQaA0`,
	"avatarImage": `MessagesItem-avatarImage-fXlEy`,
	"linkText": `MessagesItem-linkText-dbs2t`,
	"avartarSectionWidth": `MessagesItem-avartarSectionWidth-T5PEh`,
	"senderPadding": `MessagesItem-senderPadding-NuLWx`,
	"receiverPadding": `MessagesItem-receiverPadding-QjZSa`,
	"imageRight": `MessagesItem-imageRight-Ot4cw`,
	"bgImage": `MessagesItem-bgImage-lFn5a`,
	"senderBgScetion": `MessagesItem-senderBgScetion-XkuQn`,
	"recsiverBgScetion": `MessagesItem-recsiverBgScetion-eum0R`,
	"textCenter": `MessagesItem-textCenter-jzUjS`,
	"batchIcon": `MessagesItem-batchIcon-zB2Rc`,
	"positionRelative": `MessagesItem-positionRelative-eTR2Q`,
	"batchIconDriver": `MessagesItem-batchIconDriver-bCuzg`
};
module.exports = ___CSS_LOADER_EXPORT___;
